import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import TrackingListPage from './Features/TrackingList'
import HistoryListPage from './Features/HistoryList'

const TrackingPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('manage', 'Tracking', 'create') ? (
            <TrackingListPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/printed"
        element={
          ability.can('manage', 'Tracking', 'printed') ? (
            <HistoryListPage />
          ) : (
            <NotFound />
          )
        }
      />
    </Routes>
  )
}

export default TrackingPage
